import { clearBreadcrumbFeatures } from '../../../layers/breadcrumbAndRoutes/clearBreadcrumbFeatures'
import { clearDepotFeatures } from '../../../layers/depot/clearDepotFeatures'
import { clearDeviceFeatures } from '../../../layers/device/clearDeviceFeatures'
import { clearGeofenceFeatures } from '../../../layers/geofence/clearGeofenceFeatures'
import { clearOrderFeatures } from '../../../layers/order/clearOrderFeatures'
import { clearPlaceFeatures } from '../../../layers/place/clearPlaceFeatures'
import { clearRegionFeatures } from '../../../layers/region/clearRegionFeatures'
import { clearRoadSegmentFeatures } from '../../../layers/roadSegment/clearRoadSegmentFeatures'
import { clearTrafficAreaFeatures } from '../../../layers/trafficArea/clearTrafficAreaFeatures'
import { clearVehicleFeatures } from '../../../layers/vehicle/clearVehicleFeatures'

export const clearMarkerLayers = () => {
  clearOrderFeatures()
  clearDepotFeatures()
  clearPlaceFeatures()
  clearDeviceFeatures()
  clearRegionFeatures()
  clearVehicleFeatures()
  clearGeofenceFeatures()
  clearBreadcrumbFeatures()
  clearRoadSegmentFeatures()
  clearTrafficAreaFeatures()
  //clearRoutePolylineFeatures()
}
